// src/pages/home/UpdateDataButton.js  (DEMO VERSION UPDATED to match REAL popup style)
import React, { useState } from "react";
import "./DownloadExcelButton.css"; // reuse styles
import config from "../../config.json";

const UPDATE_PASSWORD = config.password;

export default function UpdateDataButton() {
  // ✅ Pretty popup state (same pattern as DataModal / CalendarLog)
  const [popup, setPopup] = useState({
    open: false,
    title: "",
    message: "",
  });

  const openPopup = (title, message) => {
    setPopup({
      open: true,
      title: title || "",
      message: message || "",
    });
  };

  const closePopup = () => {
    setPopup((p) => ({ ...p, open: false }));
  };

  function handleUpdate() {
    const pwd = prompt("Enter update password:");
    if (!pwd) return;

    // ❌ wrong password → pretty popup (no alerts)
    if (pwd !== UPDATE_PASSWORD) {
      openPopup(
        "Incorrect password",
        "The password is incorrect.\nPlease try again."
      );
      return;
    }

    // ✅ success message (keep your exact demo wording + disclaimer)
    openPopup(
      "Shelterluv sync started",
      "Shelterluv sync started.\n\n" +
        "You can reload this page in a couple of minutes to see updated data.\n\n" +
        "— Demo Notice: This feature is disabled in the demo version and does not actually sync."
    );

    // ❌ DEMO: do not call backend
    // (intentionally no fetch)
  }

  return (
    <>
      <button
        className="excel-button update-button"
        onClick={handleUpdate}
        type="button"
      >
        Update Data
      </button>

      {/* ✅ Pretty popup (same design as elsewhere) */}
      {popup.open && (
        <div className="pretty-popup-overlay" onMouseDown={closePopup}>
          <div
            className="pretty-popup"
            onMouseDown={(e) => e.stopPropagation()}
          >
            {popup.title && (
              <div className="pretty-popup-title">{popup.title}</div>
            )}

            <div className="pretty-popup-body">
              {String(popup.message || "")
                .split("\n")
                .map((line, idx) => (
                  <div key={idx} className="pretty-popup-line">
                    {line === "" ? "\u00A0" : line}
                  </div>
                ))}
            </div>

            <button
              className="pretty-popup-close"
              onClick={closePopup}
              type="button"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}
